import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { getByTimezoneRpc } from '../../__generated__/chirp/com/hubspot/user/timezones/rpc/MomentTimezonesRpc';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export default class UserTimezonesApi {}
UserTimezonesApi.moment = timezoneId => {
  return rpcClient.call(getByTimezoneRpc, {
    request: {
      timezoneId
    }
  }).then(({
    momentTimezone
  }) => {
    if (!(momentTimezone !== null && momentTimezone !== void 0 && momentTimezone.data)) {
      throw new Error(`Unknown timezone: ${timezoneId}`);
    }
    return {
      timezoneId: momentTimezone.timezoneId,
      data: momentTimezone.data
    };
  });
};